// Phase 13 · Step 16: read a vendor document with AI. Hosted: the file goes to this couple's ai-inbox folder and the
// server reads it with the studio's key. Browser-only: the browser sends it with her own key. Nothing is saved here;
// the review dialog decides. Returns { fields, confidence, warnings, raw, file } (file: the stored copy, hosted only).
import { getActiveStore } from "./store.js";
import { callFunction } from "./supabase.js";
import { callClaude } from "./ai.js";
import { EXTRACT_SYSTEM, extractPrompt, parseExtraction, checkExtractFile, contentBlock } from "../../supabase/functions/_shared/extract.js";

const fileType = file => String(file.type || "").toLowerCase() || ({ pdf: "application/pdf", jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png" })[(/\.([a-z0-9]+)$/i.exec(file.name || "") || [])[1]?.toLowerCase()] || "";

function readBase64(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(String(r.result).split(",")[1] || "");
    r.onerror = () => rej(new Error("That file couldn't be read. Try choosing it again."));
    r.readAsDataURL(file);
  });
}

export async function extractVendorDoc({ clientId, file, settings, categories }) {
  const problem = checkExtractFile({ name: file.name, type: file.type, size: file.size });
  if (problem) throw new Error(problem);
  const st = getActiveStore();
  if (st.mode === "cloud") {
    const typed = file.type ? file : new File([file], file.name, { type: fileType(file) });
    const stored = await st.uploadDocFile(clientId + "/ai-inbox", typed);
    try {
      const r = await callFunction("ai", { action: "extract-vendor", studioId: st.studioId, clientId, path: stored.path, categories });
      return { fields: r.fields, confidence: r.confidence, warnings: r.warnings || [], raw: r.raw || "", file: stored };
    } catch (e) {
      // Nothing to review, so the uploaded copy goes too.
      if (st.deleteDocFile) await st.deleteDocFile(stored.path);
      throw e;
    }
  }
  const base64 = await readBase64(file);
  const r = await callClaude(settings, { system: EXTRACT_SYSTEM, prompt: extractPrompt(categories), maxTokens: 1500, attachments: [contentBlock(fileType(file), base64)] });
  const parsed = parseExtraction(r.text, categories);
  if (!parsed.ok) throw new Error("I couldn't read that document. Try a clearer scan or a PDF.");
  return { fields: parsed.fields, confidence: parsed.confidence, warnings: parsed.warnings, raw: r.text, file: null };
}
